import { NavLink } from "react-router-dom";
import { useState } from "react";
import logo from "../../assets/Cimation Ticketing System.jpeg";
import NavBar from "./NavBar";
import MenuIcon from "@mui/icons-material/Menu";

const Header = ({ confirmLogout, showHeader }) => {
  // const [showHeader, setHeader] = useState(true);

  // function toggleShow() {
  //   setHeader(!showHeader);
  // }

  return (
    <div /*style={{ display: "flex" }}*/>
      {/* <button  onClick={toggleShow}>
        <MenuIcon />
      </button> */}
      {showHeader && (
        <header>
          <div className="nav-area">
            <NavLink to="/Home">
              <img
                src={logo}
                alt="Cimation logo"
                width="240px"
                height="56px"
                sx={{
                  display: { xs: "none", md: "flex" },
                  mr: 1,
                }}
              ></img>
            </NavLink>
            <NavBar confirmLogout={confirmLogout} />
          </div>
        </header>
      )}
    </div>
    //   <div style={{ display: "flex" }}>
    //   {/* <Hamburger toggled={showHeader} toggle={toggleHamburger}>
    //     {showHeader ? <></> : <></>}
    //   </Hamburger> */}
    //   <header>
    //     <div className="nav-area">
    //       <Link to="/">
    //         <img
    //           src={logo}
    //           alt="Cimation logo"
    //           width="140px"
    //           height="56px"
    //           sx={{
    //             display: { xs: "none", md: "flex" },
    //             mr: 1,
    //           }}
    //         ></img>
    //       </Link>
    //       <NavBar confirmLogout={confirmLogout} />
    //     </div>
    //   </header>
    // </div>
  );
};

export default Header;
